import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=c78d7b50&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VResponsive})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c78d7b50')) {
      api.createRecord('c78d7b50', component.options)
    } else {
      api.reload('c78d7b50', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=c78d7b50&", function () {
      api.rerender('c78d7b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageNotFound.vue"
export default component.exports